export class LoadReportsFailure {
    public static readonly type = '[JobsPlacements] Load reports failure';
}
